
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.75.75a10.485 10.485 0 0 0-8.917 16.025L.75 23.25l6.475-3.083A10.5 10.5 0 1 0 12.75.75Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M15.75 13.5a3 3 0 0 1-6 0Zm-7.5-4.125h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m9 0h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    